import { FormProvider, yupResolver } from '@slal/ui/react-hook-form/core';
import { CheckboxField, Field } from '@slal/ui/react-hook-form/fields';
import { Heading } from '@slal/ui/typography';
import { useNavigate } from 'react-router';
import { StyledForm } from '~/components';
import { useApplicationForm } from '~/hooks';
import { cashLikeFundDeclarationValidationSchema } from '~/schemas';
import { ApplicationFormKeys, CashLikeFundDeclarationSchema } from '~/types';
import { ApplicationButtons } from '../ApplicationButtons';
import { StyledDeclarationsLabel } from './styles';

const DeclarationsLabel = () => {
    return (
        <StyledDeclarationsLabel>
            I understand and I am comfortable proceeding with my decision.
        </StyledDeclarationsLabel>
    );
};

export const CashLikeFundDeclarationForm = () => {
    const { handleSubmit, form } = useApplicationForm<CashLikeFundDeclarationSchema>(
        {
            defaultValues: { cashLikeFundDeclaration: { consent: false } },
            resolver: yupResolver(cashLikeFundDeclarationValidationSchema),
        },
        ApplicationFormKeys.CASH_LIKE_FUND_DECLARATION
    );

    const navigate = useNavigate();
    const onValidCallback = () => navigate('/application/key-considerations/information');

    return (
        <>
            <Heading level={4}>Select to agree</Heading>
            <FormProvider {...form}>
                <StyledForm onSubmit={handleSubmit(onValidCallback)}>
                    <Field errorFor="cashLikeFundDeclaration.consent">
                        <CheckboxField label={<DeclarationsLabel />} name="cashLikeFundDeclaration.consent" />
                    </Field>
                    <ApplicationButtons backTo="/application/fund-options" />
                </StyledForm>
            </FormProvider>
        </>
    );
};
